<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.96222 11.8034C8.79836 11.8034 8.68912 11.9263 8.68912 12.0765V12.7183C8.68912 12.8822 8.79836 12.9914 8.96222 12.9914H11.0378C11.188 12.9914 11.3109 12.8822 11.3109 12.7183V12.0765C11.3109 11.9263 11.188 11.8034 11.0378 11.8034H10.7647V8.89487C10.7647 8.74467 10.6418 8.62177 10.4916 8.62177H8.96222C8.79836 8.62177 8.68912 8.74467 8.68912 8.89487V9.55032C8.68912 9.70052 8.79836 9.82342 8.96222 9.82342H9.23532V11.8034H8.96222ZM10 6C9.4538 6 9.01684 6.45062 9.01684 6.98317C9.01684 7.52937 9.4538 7.96633 10 7.96633C10.5326 7.96633 10.9832 7.52937 10.9832 6.98317C10.9832 6.45062 10.5326 6 10 6Z"
            fill="#828292"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 16.125C13.3827 16.125 16.125 13.3827 16.125 10C16.125 6.61726 13.3827 3.875 10 3.875C6.61726 3.875 3.875 6.61726 3.875 10C3.875 13.3827 6.61726 16.125 10 16.125ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
            fill="#828292"
        />
    </svg>
</template>
